module.exports = __webpack_public_path__ + "img/pic_general.e7c82c23.jpg";